export default __webpack_public_path__ + "static/media/IBMChat.12913eef.svg";